import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../../components/Button/Button'
import { SEND_BOOKING_INVITATIONS_BACK } from './sendBookingInvitationsCopy'

interface SendBookingInvitationsHeaderProps {
  backTo: string
}

export const SendBookingInvitationsHeader: React.FC<SendBookingInvitationsHeaderProps> = ({ backTo }) => {
  const navigate = useNavigate()

  return (
    <div className='zocks-pl-2.0'>
      <Button variant='link' className='back-button' aria-label={SEND_BOOKING_INVITATIONS_BACK} onClick={() => navigate(backTo)}>
        <i className='bi bi-chevron-left' aria-hidden='true' />
      </Button>
    </div>
  )
}
